import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { IconsModule } from "@va/core-library/icons";
import { RightPanelComponent } from "../right-panel/right-panel/right-panel.component";
import { SharedModule } from "../shared/shared.module";
import { FormsModule } from "@angular/forms";
import { NzCollapseModule } from "ng-zorro-antd/collapse";
import { NzPopoverModule } from "ng-zorro-antd/popover";

@NgModule({
  declarations: [RightPanelComponent],
  imports: [
    CommonModule,
    NzCollapseModule,
    NzPopoverModule,
    IconsModule,
    SharedModule,
    FormsModule,
  ],
  exports: [RightPanelComponent],
})
export class RightPanelModule {}
